export interface MediaItem {
  id: string;
  title: string;
  type: "movie" | "tv";
  year: number;
  region: string;
  genres: string[];
  rating: number;
  views: number;
  duration: string;
  episodes: number;
  poster: string;
  backdrop: string;
  description: string;
  director: string;
  actors: string[];
  featured: boolean;
}

export const movies: MediaItem[] = [
  {
    id: "m1",
    title: "星尘旅人",
    type: "movie",
    year: 2025,
    region: "美国",
    genres: ["科幻", "冒险"],
    rating: 8.7,
    views: 1286000,
    duration: "142 分钟",
    episodes: 0,
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20of%20a%20lone%20astronaut%20walking%20toward%20a%20glowing%20stardust%20nebula%2C%20deep%20space%20background%2C%20dramatic%20rim%20lighting%2C%20dark%20moody%20atmosphere%2C%20vertical%20composition%2C%20high%20detail&width=400&height=600&seq=poster-cinema-m1&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Epic%20wide%20cinematic%20space%20scene%20with%20a%20lone%20astronaut%20silhouette%20facing%20a%20giant%20glowing%20violet%20nebula%20and%20floating%20stardust%2C%20deep%20dark%20cosmos%2C%20volumetric%20light%2C%20moody%20atmosphere%2C%20film%20still&width=1600&height=900&seq=backdrop-cinema-m1&orientation=landscape",
    description:
      "一场意外的空间跃迁将宇航员送往宇宙边缘，他必须依靠一段残缺的星图与仅存的氧气，在尘埃之海中找回回家的航向。",
    director: "林知远",
    actors: ["陈墨白", "苏念安", "周衍"],
    featured: true,
  },
  {
    id: "m2",
    title: "暗巷追凶",
    type: "movie",
    year: 2024,
    region: "中国香港",
    genres: ["悬疑", "犯罪"],
    rating: 8.3,
    views: 986000,
    duration: "118 分钟",
    episodes: 0,
    poster:
      "https://readdy.ai/api/search-image?query=Gritty%20noir%20crime%20movie%20poster%20of%20a%20detective%20standing%20in%20a%20rainy%20neon%20alley%20at%20night%2C%20wet%20asphalt%20reflections%2C%20tense%20mystery%20mood%2C%20dark%20teal%20shadows%2C%20vertical%20composition%2C%20cinematic&width=400&height=600&seq=poster-cinema-m2&orientation=portrait",
    backdrop: "",
    description:
      "一桩尘封十五年的悬案重新浮出水面，退休警探在雨夜的老城巷道里，一步步逼近真相与自己的心魔。",
    director: "麦子谦",
    actors: ["郭立成", "何嘉琪", "潘伟东"],
    featured: false,
  },
  {
    id: "m3",
    title: "山海拾遗",
    type: "movie",
    year: 2023,
    region: "中国大陆",
    genres: ["奇幻", "冒险"],
    rating: 8.0,
    views: 742000,
    duration: "130 分钟",
    episodes: 0,
    poster:
      "https://readdy.ai/api/search-image?query=Fantasy%20adventure%20movie%20poster%20of%20ancient%20mythical%20mountains%20with%20a%20wandering%20scholar%20holding%20a%20lamp%2C%20giant%20misty%20peaks%2C%20swirling%20clouds%2C%20mystical%20atmosphere%2C%20warm%20gold%20light%2C%20vertical%20cinematic&width=400&height=600&seq=poster-cinema-m3&orientation=portrait",
    backdrop: "",
    description:
      "年轻的书生为寻回遗失的山海图卷，踏入云深不知处的荒山，与传说中的灵兽一同揭开千年前的秘密。",
    director: "江晚舟",
    actors: ["宋清和", "叶知秋", "顧言"],
    featured: false,
  },
  {
    id: "m4",
    title: "春日信笺",
    type: "movie",
    year: 2024,
    region: "日本",
    genres: ["爱情", "剧情"],
    rating: 7.9,
    views: 623000,
    duration: "106 分钟",
    episodes: 0,
    poster:
      "https://readdy.ai/api/search-image?query=Soft%20romantic%20drama%20movie%20poster%20of%20a%20young%20woman%20reading%20a%20letter%20under%20blooming%20cherry%20blossoms%2C%20gentle%20spring%20light%2C%20pastel%20warm%20tones%2C%20tender%20melancholy%20mood%2C%20vertical%20composition&width=400&height=600&seq=poster-cinema-m4&orientation=portrait",
    backdrop: "",
    description:
      "每年春天都会收到一封没有署名的信，直到第十年，她终于决定循着字迹，找到那个一直在等待的人。",
    director: "小林彻",
    actors: ["新垣由纪", "松本涼", "高桥沙季"],
    featured: false,
  },
  {
    id: "m5",
    title: "孤城日落",
    type: "movie",
    year: 2022,
    region: "美国",
    genres: ["剧情", "冒险"],
    rating: 7.6,
    views: 512000,
    duration: "124 分钟",
    episodes: 0,
    poster:
      "https://readdy.ai/api/search-image?query=Western%20drama%20movie%20poster%20of%20a%20lone%20cowboy%20silhouette%20overlooking%20a%20desert%20town%20at%20sunset%2C%20dusty%20orange%20sky%2C%20windswept%20wide%20landscape%2C%20somber%20mood%2C%20vertical%20cinematic%20frame&width=400&height=600&seq=poster-cinema-m5&orientation=portrait",
    backdrop: "",
    description:
      "在矿业小镇即将荒废的最后一个月，一位老警长守着空荡的街道，等待一场迟到多年的告别。",
    director: "James Holloway",
    actors: ["Eddie Grant", "玛莎·利", "Cody Pruitt"],
    featured: false,
  },
  {
    id: "m6",
    title: "深海回响",
    type: "movie",
    year: 2025,
    region: "英国",
    genres: ["科幻", "惊悚"],
    rating: 8.5,
    views: 1104000,
    duration: "134 分钟",
    episodes: 0,
    poster:
      "https://readdy.ai/api/search-image?query=Deep%20sea%20sci-fi%20thriller%20poster%20of%20a%20submarine%20descending%20into%20a%20dark%20abyssal%20trench%20with%20a%20faint%20glowing%20signal%2C%20eerie%20blue-teal%20darkness%2C%20suspenseful%20mood%2C%20vertical%20cinematic&width=400&height=600&seq=poster-cinema-m6&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20deep%20sea%20scene%20of%20a%20lone%20submarine%20sinking%20into%20an%20infinite%20black%20ocean%20trench%20with%20one%20mysterious%20glowing%20blue%20signal%20far%20below%2C%20immersive%20dark%20atmosphere%2C%20film%20still&width=1600&height=900&seq=backdrop-cinema-m6&orientation=landscape",
    description:
      "深海勘探队接收到一段来自马里亚纳海沟的规律信号，随着下潜深度增加，他们发现黑暗之中并非空无一物。",
    director: "Oliver Bennett",
    actors: ["Amelia Frost", "丹尼尔·凯", "Sofia Reyes"],
    featured: true,
  },
  {
    id: "m7",
    title: "江湖小馆",
    type: "movie",
    year: 2023,
    region: "中国大陆",
    genres: ["喜剧", "古装"],
    rating: 7.8,
    views: 688000,
    duration: "112 分钟",
    episodes: 0,
    poster:
      "https://readdy.ai/api/search-image?query=Warm%20wuxia%20comedy%20movie%20poster%20of%20a%20cozy%20ancient%20Chinese%20tavern%20with%20lanterns%20and%20a%20smiling%20innkeeper%2C%20golden%20warm%20light%2C%20lighthearted%20atmosphere%2C%20detailed%20vertical%20composition&width=400&height=600&seq=poster-cinema-m7&orientation=portrait",
    backdrop: "",
    description:
      "一间开在荒道边的破旧小馆，专收江湖上的失意人。老板一碗热汤下肚，恩怨情仇都成了下酒的笑谈。",
    director: "沈家明",
    actors: ["范一舟", "柳如烟", "乔半山"],
    featured: false,
  },
  {
    id: "m8",
    title: "逆光奔跑",
    type: "movie",
    year: 2024,
    region: "中国大陆",
    genres: ["运动", "剧情"],
    rating: 8.1,
    views: 705000,
    duration: "121 分钟",
    episodes: 0,
    poster:
      "https://readdy.ai/api/search-image?query=Inspirational%20sports%20drama%20poster%20of%20a%20determined%20young%20runner%20sprinting%20at%20sunrise%20on%20a%20stadium%20track%2C%20backlit%20golden%20light%2C%20sweat%20and%20motion%2C%20hopeful%20energetic%20mood%2C%20vertical%20cinematic&width=400&height=600&seq=poster-cinema-m8&orientation=portrait",
    backdrop: "",
    description:
      "被诊断失去爆发力的短跑选手，在退役教练的鼓励下改练长跑，只为在终点线上再见一次自己十九岁的影子。",
    director: "许安然",
    actors: ["温子航", "舒曼", "霍远"],
    featured: false,
  },
  {
    id: "m9",
    title: "雾都疑云",
    type: "movie",
    year: 2021,
    region: "英国",
    genres: ["悬疑", "剧情"],
    rating: 8.2,
    views: 596000,
    duration: "127 分钟",
    episodes: 0,
    poster:
      "https://readdy.ai/api/search-image?query=Victorian%20mystery%20movie%20poster%20of%20a%20silhouette%20walking%20through%20a%20foggy%20cobblestone%20street%20lit%20by%20gas%20lamps%2C%20thick%20mist%2C%20moody%20desaturated%20tones%2C%20suspenseful%20vertical%20composition&width=400&height=600&seq=poster-cinema-m9&orientation=portrait",
    backdrop: "",
    description:
      "浓雾笼罩的旧城接连发生怪案，一位被停职的记者与一位女法医联手，在煤气灯下拼凑出被刻意抹去的真相。",
    director: "Emily Carter",
    actors: ["Thomas Hale", "艾拉·莫里", "Rufus Blythe"],
    featured: false,
  },
  {
    id: "m10",
    title: "城市边缘",
    type: "movie",
    year: 2023,
    region: "法国",
    genres: ["剧情", "家庭"],
    rating: 7.7,
    views: 421000,
    duration: "115 分钟",
    episodes: 0,
    poster:
      "https://readdy.ai/api/search-image?query=Intimate%20urban%20family%20drama%20poster%20of%20a%20father%20and%20child%20holding%20hands%20on%20a%20quiet%20city%20outskirt%20street%20at%20dusk%2C%20soft%20amber%20streetlights%2C%20warm%20bittersweet%20mood%2C%20vertical%20cinematic&width=400&height=600&seq=poster-cinema-m10&orientation=portrait",
    backdrop: "",
    description:
      "一对在郊区生活的父女，用一年的时间修理一辆旧车，也在修理那些说不出口的裂痕。",
    director: "Luc Moreau",
    actors: ["Claire Dubois", "Hugo Petit", "娜蒂亚·罗"],
    featured: false,
  },
  {
    id: "m11",
    title: "时光信箱",
    type: "movie",
    year: 2025,
    region: "韩国",
    genres: ["爱情", "奇幻"],
    rating: 8.4,
    views: 967000,
    duration: "119 分钟",
    episodes: 0,
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20fantasy%20movie%20poster%20of%20an%20old%20mailbox%20glowing%20with%20letters%20floating%20into%20a%20starry%20night%20sky%2C%20whimsical%20warm%20glow%2C%20dreamy%20atmosphere%2C%20vertical%20cinematic%20composition&width=400&height=600&seq=poster-cinema-m11&orientation=portrait",
    backdrop: "",
    description:
      "一只老旧的信箱能把信寄回过去，两个相隔十年的陌生人因此相识，却要在改变未来的代价前做出选择。",
    director: "朴振宇",
    actors: ["金하늘", "李서준", "车敏珠"],
    featured: false,
  },
  {
    id: "m12",
    title: "钢铁洪流",
    type: "movie",
    year: 2024,
    region: "中国大陆",
    genres: ["动作", "战争"],
    rating: 8.0,
    views: 883000,
    duration: "138 分钟",
    episodes: 0,
    poster:
      "https://readdy.ai/api/search-image?query=Intense%20war%20action%20movie%20poster%20of%20a%20tank%20convoy%20advancing%20through%20smoke%20and%20sparks%20at%20dawn%2C%20dust%20and%20fire%2C%20dramatic%20grey%20orange%20tones%2C%20epic%20vertical%20cinematic&width=400&height=600&seq=poster-cinema-m12&orientation=portrait",
    backdrop: "",
    description:
      "一支装甲连队奉命守住最后的渡口，在钢铁与炮火之间，他们守护的不只是阵地，还有身后的家。",
    director: "赵铁峰",
    actors: ["马景行", "陆沉", "白羽"],
    featured: false,
  },
  {
    id: "m13",
    title: "月下骑士",
    type: "movie",
    year: 2022,
    region: "美国",
    genres: ["奇幻", "冒险"],
    rating: 7.5,
    views: 458000,
    duration: "126 分钟",
    episodes: 0,
    poster:
      "https://readdy.ai/api/search-image?query=Fantasy%20adventure%20poster%20of%20an%20armored%20knight%20riding%20a%20horse%20under%20a%20huge%20glowing%20full%20moon%20in%20a%20dark%20enchanted%20forest%2C%20silver%20moonlight%2C%20epic%20vertical%20composition%2C%20cinematic%20detail&width=400&height=600&seq=poster-cinema-m13&orientation=portrait",
    backdrop: "",
    description:
      "被诅咒的骑士每逢月圆便化为石像，他必须在最后一次月出之前，找到解除诅咒的古老誓言。",
    director: "Nathan Cole",
    actors: ["Oliver Reed", "伊莎贝尔·恩", "Marcus Vale"],
    featured: false,
  },
  {
    id: "m14",
    title: "无声告白",
    type: "movie",
    year: 2024,
    region: "中国大陆",
    genres: ["剧情", "家庭"],
    rating: 8.6,
    views: 812000,
    duration: "110 分钟",
    episodes: 0,
    poster:
      "https://readdy.ai/api/search-image?query=Quiet%20emotional%20family%20drama%20poster%20of%20a%20mother%20and%20deaf%20daughter%20communicating%20with%20sign%20language%20in%20a%20sunlit%20kitchen%2C%20tender%20warm%20light%2C%20gentle%20melancholy%2C%20vertical%20cinematic&width=400&height=600&seq=poster-cinema-m14&orientation=portrait",
    backdrop: "",
    description:
      "一位失语的母亲与长大成人的女儿，在整理旧屋的一天里，用手语和沉默说出了一辈子没能说出口的爱。",
    director: "程未晚",
    actors: ["梅素心", "林小满", "郑柏川"],
    featured: false,
  },
  {
    id: "m15",
    title: "极速狂飙",
    type: "movie",
    year: 2025,
    region: "美国",
    genres: ["动作", "运动"],
    rating: 7.9,
    views: 1032000,
    duration: "132 分钟",
    episodes: 0,
    poster:
      "https://readdy.ai/api/search-image?query=High%20octane%20street%20racing%20movie%20poster%20of%20a%20sports%20car%20drifting%20through%20a%20night%20city%20with%20light%20trails%2C%20motion%20blur%2C%20neon%20reflections%20and%20sparks%2C%20fast%20energetic%20vertical%20cinematic&width=400&height=600&seq=poster-cinema-m15&orientation=portrait",
    backdrop: "",
    description:
      "退役车手为救回被卷入地下车赛的弟弟，重返赛道，用一场横跨整座城市的午夜竞速赌上全部。",
    director: "Ryan Torres",
    actors: ["Jason Bloom", "凯拉·吴", "Diego Cruz"],
    featured: false,
  },
];

export const tvShows: MediaItem[] = [
  {
    id: "t1",
    title: "长安旧梦",
    type: "tv",
    year: 2024,
    region: "中国大陆",
    genres: ["古装", "历史"],
    rating: 8.8,
    views: 1560000,
    duration: "45 分钟/集",
    episodes: 42,
    poster:
      "https://readdy.ai/api/search-image?query=Grand%20historical%20Chinese%20drama%20poster%20of%20ancient%20Chang&width=400&height=600&seq=poster-cinema-t1&orientation=portrait'an%20city%20at%20dusk%20with%20palace%20roofs%20and%20lanterns%2C%20a%20robed%20figure%20on%20a%20terrace%2C%20golden%20and%20crimson%20tones%2C%20epic%20vertical%20cinematic",
    backdrop:
      "https://readdy.ai/api/search-image?query=Epic%20wide%20cinematic%20view%20of%20ancient%20Chang&width=1600&height=900&seq=backdrop-cinema-t1&orientation=landscape'an%20city%20at%20golden%20dusk%20with%20endless%20palace%20roofs%2C%20lanterns%20and%20misty%20mountains%2C%20rich%20amber%20and%20crimson%20tone%2C%20grand%20historical%20atmosphere%2C%20film%20still",
    description:
      "盛世长安的宫墙之内，一位出身寒微的女官与年轻的皇子，在权谋与理想之间，共同守护这座城池最后的荣光。",
    director: "顾长风",
    actors: ["沈青梧", "萧景桓", "苏玉屏"],
    featured: true,
  },
  {
    id: "t2",
    title: "都市浮沉",
    type: "tv",
    year: 2023,
    region: "中国大陆",
    genres: ["都市", "剧情"],
    rating: 8.1,
    views: 924000,
    duration: "42 分钟/集",
    episodes: 36,
    poster:
      "https://readdy.ai/api/search-image?query=Modern%20urban%20drama%20poster%20of%20a%20businessman%20standing%20before%20a%20glass%20skyscraper%20at%20night%2C%20city%20lights%20reflection%2C%20cool%20grey%20tones%20with%20warm%20accents%2C%20vertical%20cinematic&width=400&height=600&seq=poster-cinema-t2&orientation=portrait",
    backdrop: "",
    description:
      "三位大学同窗在房地产行业的黄金年代携手创业，也在一场突如其来的寒冬里，重新审视友情与野心。",
    director: "周榕",
    actors: ["陆则言", "唐悠然", "孟亦飞"],
    featured: false,
  },
  {
    id: "t3",
    title: "苍穹之上",
    type: "tv",
    year: 2025,
    region: "中国大陆",
    genres: ["科幻", "剧情"],
    rating: 8.7,
    views: 1340000,
    duration: "50 分钟/集",
    episodes: 24,
    poster:
      "https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20series%20poster%20of%20a%20giant%20orbital%20space%20station%20above%20a%20blue%20planet%2C%20small%20shuttle%20approaching%2C%20clean%20high-tech%20aesthetic%2C%20deep%20space%20darkness%20with%20glowing%20accents%2C%20vertical&width=400&height=600&seq=poster-cinema-t3&orientation=portrait",
    backdrop: "",
    description:
      "当地球资源耗尽，人类在近地轨道建起最后一座太空城。一名年轻工程师发现，维持城市的系统正悄然失控。",
    director: "方远航",
    actors: ["江晨", "夏以宁", "裴然"],
    featured: false,
  },
  {
    id: "t4",
    title: "医者仁心",
    type: "tv",
    year: 2022,
    region: "中国大陆",
    genres: ["医疗", "剧情"],
    rating: 8.3,
    views: 786000,
    duration: "44 分钟/集",
    episodes: 40,
    poster:
      "https://readdy.ai/api/search-image?query=Medical%20drama%20poster%20of%20a%20team%20of%20doctors%20in%20scrubs%20walking%20through%20a%20bright%20hospital%20corridor%2C%20clean%20white%20and%20teal%20tones%2C%20determined%20hopeful%20mood%2C%20vertical%20cinematic&width=400&height=600&seq=poster-cinema-t4&orientation=portrait",
    backdrop: "",
    description:
      "急诊科的日与夜，一群年轻医生在生死之间学习成长，也在一次次抉择中重新理解「仁心」二字的分量。",
    director: "仁怀远",
    actors: ["顾南亭", "许知微", "沈砚"],
    featured: false,
  },
  {
    id: "t5",
    title: "迷雾档案",
    type: "tv",
    year: 2024,
    region: "中国大陆",
    genres: ["悬疑", "犯罪"],
    rating: 8.6,
    views: 1180000,
    duration: "46 分钟/集",
    episodes: 28,
    poster:
      "https://readdy.ai/api/search-image?query=Crime%20thriller%20series%20poster%20of%20a%20detective%20examining%20evidence%20files%20under%20a%20single%20lamp%20in%20a%20dark%20office%2C%20cold%20moody%20lighting%2C%20suspenseful%20tones%2C%20vertical%20cinematic%20composition&width=400&height=600&seq=poster-cinema-t5&orientation=portrait",
    backdrop: "",
    description:
      "档案室里一摞无人问津的旧卷宗，牵出一连串被掩盖的失踪案。年轻的档案员决定用自己的方式，让沉默的纸张开口。",
    director: "秦岭",
    actors: ["黎知行", "莫晚", "杜衡"],
    featured: false,
  },
  {
    id: "t6",
    title: "星河学院",
    type: "tv",
    year: 2023,
    region: "中国大陆",
    genres: ["青春", "奇幻"],
    rating: 7.8,
    views: 662000,
    duration: "40 分钟/集",
    episodes: 30,
    poster:
      "https://readdy.ai/api/search-image?query=Youth%20fantasy%20series%20poster%20of%20students%20gathered%20in%20a%20magical%20academy%20courtyard%20with%20floating%20glowing%20orbs%20and%20starry%20sky%2C%20dreamy%20violet%20and%20gold%20tones%2C%20vertical%20cinematic&width=400&height=600&seq=poster-cinema-t6&orientation=portrait",
    backdrop: "",
    description:
      "一所只在流星之夜才会出现的学院，收留每一个与众不同的少年。关于成长、友谊与选择的故事，在星光下缓缓展开。",
    director: "叶锦",
    actors: ["林葳", "苏晚棠", "邵一宁"],
    featured: false,
  },
  {
    id: "t7",
    title: "归途列车",
    type: "tv",
    year: 2025,
    region: "中国大陆",
    genres: ["剧情", "家庭"],
    rating: 8.4,
    views: 738000,
    duration: "43 分钟/集",
    episodes: 20,
    poster:
      "https://readdy.ai/api/search-image?query=Nostalgic%20family%20drama%20poster%20of%20a%20passenger%20train%20rolling%20through%20golden%20wheat%20fields%20at%20sunset%2C%20warm%20amber%20light%2C%20sense%20of%20homecoming%2C%20vertical%20cinematic&width=400&height=600&seq=poster-cinema-t7&orientation=portrait",
    backdrop: "",
    description:
      "一趟跨越三千公里的绿皮火车，载着五个素不相识的旅人，也载着他们各自想要回答的那个「家」在哪里。",
    director: "温子成",
    actors: ["周叙", "白露", "常安"],
    featured: false,
  },
  {
    id: "t8",
    title: "商海风云",
    type: "tv",
    year: 2021,
    region: "中国大陆",
    genres: ["商战", "剧情"],
    rating: 8.0,
    views: 690000,
    duration: "45 分钟/集",
    episodes: 45,
    poster:
      "https://readdy.ai/api/search-image?query=Corporate%20drama%20series%20poster%20of%20confident%20executives%20in%20a%20boardroom%20with%20city%20skyline%20through%20windows%2C%20sleek%20dark%20tones%20with%20gold%20accents%2C%20tense%20ambitious%20mood%2C%20vertical&width=400&height=600&seq=poster-cinema-t8&orientation=portrait",
    backdrop: "",
    description:
      "从一间车库起家的公司，到横跨两代的家族企业。资本与人心的博弈里，没有永远的赢家，只有不断的抉择。",
    director: "陆廷",
    actors: ["高启铭", "宋清晏", "郑维"],
    featured: false,
  },
  {
    id: "t9",
    title: "三生小店",
    type: "tv",
    year: 2024,
    region: "中国大陆",
    genres: ["奇幻", "喜剧"],
    rating: 7.9,
    views: 715000,
    duration: "38 分钟/集",
    episodes: 32,
    poster:
      "https://readdy.ai/api/search-image?query=Whimsical%20fantasy%20comedy%20poster%20of%20a%20cozy%20magical%20shop%20overflowing%20with%20glowing%20trinkets%20and%20potion%20bottles%2C%20warm%20lantern%20glow%2C%20charming%20cozy%20atmosphere%2C%20vertical%20cinematic&width=400&height=600&seq=poster-cinema-t9&orientation=portrait",
    backdrop: "",
    description:
      "街角有家只在深夜营业的小店，老板不卖货物，只出售「重来一次」的机会，而每一次机会都有它的价码。",
    director: "苏半城",
    actors: ["阿箬", "时予", "白九"],
    featured: false,
  },
  {
    id: "t10",
    title: "黎明之前",
    type: "tv",
    year: 2022,
    region: "中国大陆",
    genres: ["谍战", "历史"],
    rating: 8.5,
    views: 852000,
    duration: "46 分钟/集",
    episodes: 38,
    poster:
      "https://readdy.ai/api/search-image?query=Espionage%20period%20drama%20poster%20of%20a%20man%20in%20a%20trench%20coat%20and%20hat%20in%20a%20rainy%20old%20city%20street%20at%20night%2C%20lamp%20glow%2C%20tense%20desaturated%20mood%2C%20vertical%20cinematic%20composition&width=400&height=600&seq=poster-cinema-t10&orientation=portrait",
    backdrop: "",
    description:
      "黎明到来之前，是最深的夜。一位潜伏者游走在敌我之间，用孤独与沉默，等待那座城市迎来第一缕光。",
    director: "孟寒",
    actors: ["沈孤鸿", "程雪", "傅安"],
    featured: false,
  },
  {
    id: "t11",
    title: "燃烧的青春",
    type: "tv",
    year: 2023,
    region: "中国大陆",
    genres: ["青春", "励志"],
    rating: 7.7,
    views: 588000,
    duration: "40 分钟/集",
    episodes: 26,
    poster:
      "https://readdy.ai/api/search-image?query=Energetic%20youth%20inspirational%20series%20poster%20of%20a%20band%20of%20friends%20playing%20music%20on%20a%20rooftop%20at%20golden%20hour%2C%20city%20skyline%20behind%2C%20vibrant%20warm%20tones%2C%20hopeful%20mood%2C%20vertical%20cinematic&width=400&height=600&seq=poster-cinema-t11&orientation=portrait",
    backdrop: "",
    description:
      "五个怀揣梦想的年轻人，把一间废弃天台改造成排练室。青春也许会散场，但那段燃烧过的旋律不会。",
    director: "何夕",
    actors: ["许星野", "安然", "陈即"],
    featured: false,
  },
  {
    id: "t12",
    title: "美食江湖",
    type: "tv",
    year: 2025,
    region: "中国大陆",
    genres: ["美食", "喜剧"],
    rating: 8.0,
    views: 640000,
    duration: "35 分钟/集",
    episodes: 18,
    poster:
      "https://readdy.ai/api/search-image?query=Appetizing%20food%20comedy%20series%20poster%20of%20a%20steaming%20wok%20with%20colorful%20dishes%20on%20a%20night%20market%20stall%2C%20warm%20red%20lantern%20glow%2C%20lively%20cozy%20atmosphere%2C%20vertical%20cinematic&width=400&height=600&seq=poster-cinema-t12&orientation=portrait",
    backdrop: "",
    description:
      "夜市尽头的一辆餐车，老板脾气古怪却手艺了得。每一位食客的故事，都炒进了那口翻滚的铁锅里。",
    director: "王大厨",
    actors: ["古三味", "李小满", "阿福"],
    featured: false,
  },
  {
    id: "t13",
    title: "无声之城",
    type: "tv",
    year: 2024,
    region: "韩国",
    genres: ["犯罪", "悬疑"],
    rating: 8.4,
    views: 798000,
    duration: "48 分钟/集",
    episodes: 24,
    poster:
      "https://readdy.ai/api/search-image?query=Dark%20crime%20thriller%20series%20poster%20of%20an%20empty%20rain-slicked%20city%20street%20under%20streetlight%2C%20a%20lone%20figure%20in%20shadow%2C%20cold%20moody%20tones%2C%20ominous%20atmosphere%2C%20vertical%20cinematic&width=400&height=600&seq=poster-cinema-t13&orientation=portrait",
    backdrop: "",
    description:
      "整座城市陷入一场莫名的集体沉默。一名聋哑女警用自己的方式，听到别人听不见的真相。",
    director: "郑度尹",
    actors: ["韩瑞妍", "姜泰宇", "朴善皓"],
    featured: false,
  },
];

export const movieGenres: string[] = [
  "动作",
  "爱情",
  "科幻",
  "悬疑",
  "犯罪",
  "奇幻",
  "剧情",
  "喜剧",
  "战争",
  "运动",
  "冒险",
  "惊悚",
  "家庭",
];

export const tvGenres: string[] = [
  "古装",
  "都市",
  "科幻",
  "医疗",
  "悬疑",
  "青春",
  "商战",
  "谍战",
  "喜剧",
  "美食",
  "犯罪",
  "奇幻",
  "励志",
  "历史",
];

export const regions: string[] = [
  "中国大陆",
  "中国香港",
  "美国",
  "韩国",
  "日本",
  "英国",
  "法国",
];

export const years: number[] = [2025, 2024, 2023, 2022, 2021];

export const episodeRanges: string[] = ["全部", "20 集以内", "21-40 集", "40 集以上"];